import {memo} from 'preact/compat';

const LocationsListHeader = memo( () =>
    <div className="flex-1 mb-2 md:mb-0">
        <h2 class="subheading-lg">Locations</h2>
        <p className="mb-1">Call <a href={`tel:${upi.conf.phoneTollFree}`}
                                    className="text-grey-darkest">{upi.conf.phoneTollFree}</a> to make any changes to your account</p>

        <a href="/" className="link-arrow">Back to Homepage</a>
    </div>
);

export default LocationsListHeader;
